var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mobileClass,attrs:{"id":"app"}},[(!_vm.isMobile)?_c('Desktop',{attrs:{"isMobile":_vm.isMobile,"lang":_vm.lang,"route":_vm.$route}}):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('Mobile',{attrs:{"isMobile":_vm.isMobile,"lang":_vm.lang,"route":_vm.$route}}):_vm._e(),_vm._v(" "),_c('cookies',{attrs:{"isMobile":_vm.isMobile,"lang":_vm.lang}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e27f47f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 